import { ApolloQueryResult } from "@apollo/client";
import { AxiosResponse } from "axios";
import { client } from "cache/cache";
import {
  GetMeDocument,
  GetMeQuery,
  GetMeQueryVariables,
} from "graphql/generated/schema-types";
import axios from "./AxiosService";

interface AuthService {
  getOTP(): Promise<AxiosResponse>;
  authCheck(): Promise<ApolloQueryResult<GetMeQuery>>;
}

export default {
  getOTP() {
    return axios.get("/auth/GenerateOTP");
  },
  authCheck() {
    return client.query<GetMeQuery, GetMeQueryVariables>({
      query: GetMeDocument,
    });
  },
} as AuthService;
